import { Component, EventEmitter, Input, Output } from '@angular/core';
export type EmptyContent = {
  imageSrc?: string;
  heading?: string;
  description?: string;
  actionName?: string;
  isError?: boolean;
};

@Component({
  selector: 'hospitality-bot-empty-table',
  templateUrl: './empty-table.component.html',
  styleUrls: ['./empty-table.component.scss'],
})
export class EmptyTableComponent {
  imageSrc: string;
  description: string;
  actionName: string;
  isError = false;
  @Input() disabledAction: boolean;
  @Input() link: string;
  @Input() href: string;
  @Input() isLoading: boolean;
  @Output() action = new EventEmitter();
  @Input() height: string;
  @Input() queryParams: Record<string, any> = {};
  @Input() queryParamsHandling: 'preserve' | 'merge' = 'merge';

  /**
   * Set Content of the empty view.
   */
  @Input() set content(value: EmptyContent) {
    Object.entries(value).forEach(([key, value]) => {
      this[key] = value;
    });
  }

  @Output() create = new EventEmitter();

  /**
   * Trigger create action
   */
  onActionClick() {
    this.create.emit();
  }
}
